export default {
    name: 'CodeBlock',
    props: {
        code: {
            type: String,
            required: false,
            default: ''
        },
        maxHeight: {
            type: String,
            required: false,
            default: 'initial'
        }
    },
    computed: {
        styleObject () {
            const { maxHeight } = this;
            const isScrollable = maxHeight !== 'initial';
            const scrollableStyles = {
                maxHeight,
                overflowY: 'auto'
            };
            return isScrollable ? scrollableStyles : null;
        }
    }
};
